import CompanySimple from "./CompanySimple";
import AddressSimple from "../address/AddressSimple";
import {CompanyState} from "@/helpers/constants";

export default class CompanyListEntry extends CompanySimple {

	public state!: CompanyState;
	public contactAddress!: AddressSimple;

}
